import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
/**
 * Bug #452
 * @Author Santhosh Kumar
 * @Date 21 June 2021
 */
import { signInUser } from 'api/signin';
import { activateUser, regUserFromAppt } from 'api/register';
/*** End ***/
import local from 'store2';
import { getUserDemographics, saveFcmToken } from "api"; /* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
/**
 * Bug #588 - Native Bridge call for Login and logout 
 * @Modified by Jithin Kuriakose on 03Sept2021
 * */
import NativeBridge from 'shared/utils/NativeBridge';
import { isDoctor, isDemographicsCompleted, getPlatform } from 'shared/utils/common-utils';
//End Bug #588

import defaultPic from 'client/assets/images/defaultPic.png';
import { getRandomColor } from 'utils/getRandomColor';
import { ENABLE_FCM_WEB } from 'config/FeatureFlag';
import { detectMobileApp } from 'shared/utils/detectDevice';

import stateData from "components/country-state-cities/assets/state.json";
import { ssoLogin } from 'api/sso';

const AUTH_TOKEN_KEY = 'authToken';
const initialState = {
  loading: false,
  activationPending: false,
  accountActivated: false,
  accountActivationFailed: false,
  isAuthenticated: false,
  loginSuccess: false,
  loginError: false, // Errors returned from server side
  showModalLogin: false,
  patientSelectionRequired: false, //false if no patient selected
  account: {} as any,
  practiceCode: null, //selected practice
  errorMessage: (null as unknown) as string, // Errors returned from server side
  redirectMessage: (null as unknown) as string,
  sessionHasBeenFetched: false,
  accessToken: (null as unknown) as string,
  refreshToken: (null as unknown) as string,
  username: (null as unknown) as string,
  loginInfo: {},
  logoutUrl: (null as unknown) as string,
  practiceGuid: (null as unknown) as string,
  portalProviderId: (null as unknown) as number,/** Bug #744 Midhila Velayudhan Date 16 Feb 2022 */
  providerCredentials: (null as unknown) as string,/** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
  providerSpeciality: (null as unknown) as string,/** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
  providerCode: (null as unknown) as string,/** Bug #925 @Linda Susan Raju @Date 27 May 2022 */
  fM: [] as any,/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
  cU: (null as unknown) as number,/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
  pU: (null as unknown) as number,/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
  pAU: (null as unknown) as number,/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
  getUserDemographicsSucess: false,
  broadcastMessages: [],
  portalAccountId: (null as unknown) as string,
  deviceId: (null as unknown) as string,/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
};

export const tryLogin = createAsyncThunk('authentication/tryLogin', async (params: any, opt: any) => {

  const formData = new FormData();

  formData.append('username', params.username);
  formData.append('password', params.password);
  formData.append('platform', getPlatform());
  formData.append('type', params.type);/* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
  formData.append('deviceId', params.deviceId);/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
  /**
   * Bug #452
   * @Author Santhosh Kumar
   * @Date 21 June 2021
   */
  const response = await signInUser(formData);
  /*** End ***/
  /* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
  if (response?.data) {
    response.data.type = params.type;
  }

  if(!response?.data?.data && response?.data?.list?.length > 0){
    response.data.data = response?.data?.list[0]
  }
  /** End Bug #498**/
  return response.data;
})
/**
 * Bug #498
 * @Author Jithin Kuriakose
 * @Date 13 July 2021
 */
export const tryFetchAccount = createAsyncThunk('authentication/tryFetchAccount', async () => {
  const response = await getUserDemographics();
  return response.data;
})
/**End Bug #498**/

export const saveFcmTokenToServer = createAsyncThunk('authentication/saveFcmTokenToServer', async (data) => {
  const response = await saveFcmToken(data);
  return response.data;
})
export const tryActivation = createAsyncThunk('authentication/tryActivation', async (token: any, opt: any) => {

  const formData = new FormData();

  formData.append('token', token);

  /**
   * Bug #452
   * @Author Santhosh Kumar
   * @Date 21 June 2021
   */
  const response = await activateUser(formData);
  /*** End ***/
  return response.data;
})
/** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
export const tryApptUserReg = createAsyncThunk('authentication/tryLogin', async (params: any, opt: any) => {
  const response = await regUserFromAppt(params);
  if (response?.data) {
    response.data.type = params.type;
  }
  return response.data;
})
//End Bug #782

/** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
export const trySSOLogin = createAsyncThunk('authentication/tryLogin', async (params: any) => {
  const response = await ssoLogin(params);
  if (response?.data) {
    response.data.type = params.type;
  }
  return response.data;
})
//
export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    /*Back button issue fix - Feb11-2022 */
    clearAuth: (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.getUserDemographicsSucess = false;
      state.practiceGuid = null;
      state.loginError = false;
      state.loginSuccess = false;/* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
      state.account = {}/* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
      state.fM = [];/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.cU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.pU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.pAU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.portalProviderId = null;/** Bug #744 Date :16/02/2022 */
      state.providerCredentials = null; /** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
      state.providerSpeciality = null; /** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
      state.providerCode = null; /** Bug #925 @Linda Susan Raju @Date 27 May 2022 */
      state.broadcastMessages = [];
      state.portalAccountId = null;/** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
      state.errorMessage = null;/** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
      state.deviceId = null;/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
      local.remove('deviceId');/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
      local.remove('cU');
      local.remove('aU');
      local.remove('access_token');
      local.remove('refreshToken');
      local.remove('username');
    },
    /*Back button issue fix - end */
    tryLogout: (state) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.username = null;
      state.getUserDemographicsSucess = false;
      state.practiceGuid = null;
      state.loginError = false;
      state.loginSuccess = false;/* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
      state.account = {}/* Bug #498 @Author Jithin Kuriakose @Date 13 July 2021 */
      state.fM = [];/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.cU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.pU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.pAU = null;/*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      state.portalProviderId = null;/** Bug #744 Date :16/02/2022 */
      state.providerCredentials = null; /** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
      state.providerSpeciality = null; /** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
      state.providerCode = null; /** Bug #925 @Linda Susan Raju @Date 27 May 2022 */
      state.broadcastMessages = [];
      local.remove('cU');
      local.remove('aU');
      local.remove('access_token');
      local.remove('refreshToken');
      local.remove('username');
      state.portalAccountId = null;/** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */
      state.deviceId = null;/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
      local.remove('deviceId');/**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
      NativeBridge.call('userLoggedout', { menutype: 'public', access_token: "", refresh_token: "" });/*Bug #588 - Native Bridge call for Login and logout  - Modified by Jithin Kuriakose on 03Sept2021*/
    },
    /*Bug #612 @Author Aby Joseph @Date 21 Sep 2021 */
    updateAccountInfo: (state, action) => {
      let user = {};
      if (action?.payload?.user) {
        user['id'] = action.payload.user.id;
        user['firstName'] = action.payload.user.firstName;
        user['middleName'] = action.payload.user.middleName;
        user['lastName'] = action.payload.user.lastName;
        user['email'] = action.payload.user.email;
        user['dateOfBirth'] = action.payload.user.dateOfBirth;
        user['mobileNumber'] = action.payload.user.mobileNumber;
        user['type'] = action.payload.user.type;
        user['userProfileImage'] = action.payload.user.userProfileImage;
      }
      if (action?.payload?.userDemographics) {
        user['gender'] = action.payload.userDemographics.gender;
        user['city'] = action.payload.userDemographics.city;
        user['state'] = action.payload.userDemographics.state;
        user['zipCode'] = action.payload.userDemographics.zipCode;/*Bug #611  @author Jithin Kuriakose on 23 Sept 2021*/
        user['country'] = action.payload.userDemographics.country;
        user['address1'] = action.payload.userDemographics.address1;
        user['address2'] = action.payload.userDemographics.address2;
      }
      const currentUserColor = state.fM.filter(member => member.userId === action.payload.user.id)[0]?.color;
      user['color'] = currentUserColor ? currentUserColor : getRandomColor();

      state.account = user;
    },
    /*End - Bug #612 */

    /*Bug #623 @Author Linda Susan Raju @Date 06 Oct 2021 */
    updateUserProfileImage: (state, action) => {
      let user = state.account;
      user['userProfileImage'] = action?.payload?.image;
      state.account = user;
      state.fM.map((item, i) => {
        if (item.userId === action?.payload?.id)      //Bug #670 profile image change reflect on family member list 21/12/2021
          item.userProfileImage = action?.payload?.image;

        return item;
      })
    },
    /*End Bug #623 */

    /*Bug #664  @author Aby Joseph on 06 Dec 2021*/
    updateCurrentUserId: (state, action) => {
      state.cU = action?.payload;
      local.set('cU', action?.payload);
    },
    /*End Bug #623 */
    updatefMList: (state, action) => {
      if (action?.payload) {
        action?.payload.map((item) => {
          const currentUserColor = state.fM.filter(member => member.userId === item.id)[0]?.color;
          item.color = currentUserColor ? currentUserColor : getRandomColor();

        })
        state.fM = action?.payload;
      }
    },
    updateBroadcastList: (state, action) => {
      if (action?.payload) {
        state.broadcastMessages = state?.broadcastMessages?.length > 0 ? [{ ...action?.payload, readstatus: 'unread', msgShort: 'Broadcast message from ' + action?.payload?.provider }, ...state.broadcastMessages] : [{ ...action?.payload, readstatus: 'unread', msgShort: 'Broadcast message from ' + action?.payload?.provider }];
      }
    },
    /*Bug #755  @author Aby Joseph on 17 Feb 2022*/
    updateAccessTokenInfo: (state, action) => {
      state.accessToken = action?.payload;
      local.set('access_token', action?.payload);
      NativeBridge.call('updateAccessToken', { userId: state.account.id, access_token: action?.payload });

    },
    updateRefreshTokenInfo: (state, action) => {
      state.refreshToken = action?.payload;
      local.set('refreshToken', action?.payload);
      NativeBridge.call('updateRefreshToken', { userId: state.account.id, refresh_token: action?.payload });
    },
    /*End Bug #755 */
    loginSucessWithoutFcm: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
    },
    /**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */
    updateDeviceId: (state, action) => {
      state.deviceId = action?.payload;
      local.set('deviceId', action?.payload);
    },
    //End Bug #855
  },

  extraReducers: builder => {
    builder
      .addCase(tryLogin.pending, (state, action) => {
        state.loading = true;
        state.loginError = false;
      })
      .addCase(tryLogin.fulfilled, (state, action) => {
        /** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
        if (action?.payload?.success) {
          state.loginError = false;

          state.loginSuccess = true;
          state.sessionHasBeenFetched = true;

          state.accessToken = action.payload.access_token;
          state.refreshToken = action.payload.refresh_token;/*Bug#755  @author Aby Joseph on 09 Feb 2022*/
          state.username = action.payload.username;
          state.practiceGuid = action?.payload?.practiceguid;
          state.portalAccountId = action?.payload?.data?.portalAccountFkey;/** Bug #758 - Implement filter option to select recipients for sending broadcast message @Author: Jithin Kuriakose @Date 03Mar2022 */

          /*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
          const fMembers = action.payload?.list;
          fMembers.map((item) => {

            item.color = getRandomColor();

          })
          //const fMembers  = [{"authUserId": 20,"firstName": "Adam",id: 1,"lastName": "John","middleName": "p","relation": "SELF","userId": 20}, {"authUserId": 20,"firstName": "JENNY","id": 3,"lastName":"JEFFERSON","middleName": "H","relation": "CHILD","userId": 67}];
          state.fM = fMembers;
          const selfAccount = fMembers?.filter(member => member.relation.includes("SELF"));
          state.cU = selfAccount[0].userId;
          state.pU = selfAccount[0].userId;
          state.pAU = selfAccount[0].authUserId;
          local.set('cU', selfAccount[0].userId);
          local.set('aU', selfAccount[0].userId);
          local.set('refreshToken', action.payload.refresh_token);/*Bug#755  @author Aby Joseph on 09 Feb 2022*/
          local.set('username', action.payload.username);
          /*Bug #681  - End */

          /** Bug #744 */
          if (isDoctor) {
            state.portalProviderId = action.payload?.data?.id;
            state.providerCredentials = action.payload?.data?.credentials;/** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
            state.providerSpeciality = action.payload?.data?.speciality;/** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
            state.providerCode = action.payload?.data?.providerCode; /** Bug #925 @Linda Susan Raju @Date 27 May 2022 */
          }
          /**End #744 */
          local.set('access_token', action.payload.access_token)
        }
        else {
          let isApptReg = action?.meta?.arg && action?.meta?.arg?.patientLinkNumber;
          let errorMsg = isApptReg ? (action.payload?.message ? action.payload?.message : "Registration Failed, please try again") : (action.payload?.message ? action.payload?.message : "Invalid Username or Password");
          NativeBridge.call('tryLogin', { status: 'rejected', errorMessage: errorMsg }); /**Bug#796 Modified by Linda Susan Raju on 17 March 2022 */
          state.errorMessage = errorMsg; ///action.payload;
          state.loading = false;
          state.loginError = true;
        }
        //End Bug #782
      })

      .addCase(tryLogin.rejected, (state, action) => {
        /** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
        let isApptReg = action?.meta?.arg && action?.meta?.arg?.patientLinkNumber;
        let errorMsg = isApptReg ? "Registration Failed, please try again" : "Invalid Username or Password";
        NativeBridge.call('tryLogin', { status: 'rejected', errorMessage: errorMsg }); /**Bug#796 Modified by Linda Susan Raju on 17 March 2022 */
        state.errorMessage = errorMsg; ///action.payload;
        //End Bug #782
        state.loading = false;
        state.loginError = true;
      }).addCase(tryActivation.pending, (state, action) => {
        state.activationPending = true;
      }).addCase(tryActivation.fulfilled, (state, action) => {
        if (action.payload.success === true) {
          state.accountActivationFailed = false;
          state.accountActivated = true;
          state.activationPending = false;
        } else {
          state.accountActivationFailed = true;
          state.accountActivated = false;
          state.activationPending = false;
        }

      }).addCase(tryActivation.rejected, (state, action) => {
        state.accountActivationFailed = true;
        state.accountActivated = false;
        state.activationPending = false;
      })
      /**
      * Bug #498
      * @Author Jithin Kuriakose
      * @Date 13 July 2021
      */
      .addCase(tryFetchAccount.pending, (state, action) => {
        state.account = {};
      }).addCase(tryFetchAccount.fulfilled, (state, action) => {
        if (action.payload.success) {
          let user = {};
          if (action?.payload?.data?.user) {
            user['id'] = action.payload.data.user.id;
            user['firstName'] = action.payload.data.user.firstName;
            user['middleName'] = action.payload.data.user.middleName;
            user['lastName'] = action.payload.data.user.lastName;
            user['email'] = action.payload.data.user.email;
            user['dateOfBirth'] = action.payload.data.user.dateOfBirth;
            user['mobileNumber'] = action.payload.data.user.mobileNumber;
            user['type'] = action.payload.data.user.type;
            user['userProfileImage'] = action.payload.data.user.userProfileImage == null ? defaultPic : action.payload.data.user.userProfileImage;
          }
          if (action?.payload?.data?.userDemographics) {
            user['gender'] = action.payload.data.userDemographics.gender;
            user['city'] = action.payload.data.userDemographics.city;
            user['state'] = action.payload.data.userDemographics.state;
            user['zipCode'] = action.payload.data.userDemographics.zipCode;/*Bug #611  @author Jithin Kuriakose on 23 Sept 2021*/
            user['country'] = action.payload.data.userDemographics.country;
            user['address1'] = action.payload.data.userDemographics.address1;
            user['address2'] = action.payload.data.userDemographics.address2;
          }
          const currentUserColor = state.fM.filter(member => member.userId === action.payload.data.user.id)[0]?.color;
          user['color'] = currentUserColor ? currentUserColor : getRandomColor();
          state.account = user;
          /**
           * Bug #588 - Native Bridge call for Login and logout  
           * @Modified by Jithin Kuriakose on 03Sept2021
           * */
          
            state.isAuthenticated = true;
            NativeBridge.call('userLoggedIn', {
              menutype: 'practice', userId: state?.account?.id, access_token: local.get('access_token'), refresh_token: local.get('refreshToken'),
              providerDetails: {
                portalAccountId: state?.portalAccountId, firstName: state?.account?.firstName, middleName: state?.account?.middleName, lastName: state?.account?.lastName,
                providerCredentials: state?.providerCredentials, providerSpeciality: state?.providerSpeciality, providerCode: state?.providerCode,
                address: state?.account?.address1 + ", " + state?.account?.address2, city: state?.account?.city, state: state?.account?.state, country: state?.account?.country, zipCode: state?.account?.zipCode,
                email: state?.account?.email, mobileNumber: state?.account?.mobileNumber
              }/** Bug #925 @Linda Susan Raju @Date 25 May 2022 */
            });
          
          //End Bug #588
          if (!ENABLE_FCM_WEB) {
            state.isAuthenticated = true;
            state.loading = false;
          }
          // state.loading = false;
        } else {
          state.account = {};
          state.getUserDemographicsSucess = false;
          state.isAuthenticated = false;
          state.loading = false;
          state.loginSuccess = false;
        }
      }).addCase(tryFetchAccount.rejected, (state, action) => {
        state.account = {};
        state.isAuthenticated = false;
        state.getUserDemographicsSucess = false;
        state.loading = false;
        state.loginSuccess = false;
      }).addCase(saveFcmTokenToServer.pending, (state, action) => {
        state.loading = true;
      }).addCase(saveFcmTokenToServer.fulfilled, (state, action) => {
        state.getUserDemographicsSucess = false;
        if (action.payload.success) {
          state.isAuthenticated = true;
          state.loading = false;
        } else {
          state.account = {};
          state.isAuthenticated = false;
          state.loading = false;
          state.loginSuccess = false;
        }
      }).addCase(saveFcmTokenToServer.rejected, (state, action) => {
        state.getUserDemographicsSucess = false;
        state.account = {};
        state.isAuthenticated = false;
        state.loading = false;
        state.loginSuccess = false;
      })
    /**End Bug #498**/
  }
});

export const { clearAuth, tryLogout, loginSucessWithoutFcm, updateAccountInfo, updateUserProfileImage, updateCurrentUserId, updatefMList, updateBroadcastList, updateAccessTokenInfo, updateRefreshTokenInfo, updateDeviceId } = authenticationSlice.actions;/*Bug #612 @Author Aby Joseph @Date 21 Sep 2021 - 'updateAccountInfo' added*/ /*Bug #755 @Author Aby Joseph @Date 17 Feb 2022 - 'updateAccessTokenInfo,updateRefreshTokenInfo'added*/ /**Bug #855 - Refresh token management in web, Bug #854 @Author Jithin Kuriakose @Date 26Apr2022 */

export const clearAuthToken: () => void = () => dispatch => {
  dispatch(clearAuth());
  local.clearAll();
};

// export const logout: () => void = () => dispatch => {
//   console.log("Refresh token expired,logout   logout");
//   if(ENABLE_FCM_WEB){
//     requestPermission().then((permission) => {
//       if (permission === 'granted') {
//         deleteToken().then(async()  => {

//           // ...
//         }).catch((err) => {
//         });
//       }
//       dispatch(tryLogout());
//       local.clearAll();
//     }).catch((err) => {
//       dispatch(tryLogout());
//       local.clearAll();
//     });
//   }else{
//     console.log("Refresh token expired, logout");
//     dispatch(tryLogout());
//     local.clearAll();
//   }
// };

// export const singoutCall: () => void = () => dispatch => {
//   dispatch(tryLogout());
//   local.clearAll();
// }
export const setLoginSuccess = params => dispatch => {

  dispatch(loginSucessWithoutFcm(params));

};

export const clearAuthentication = messageKey => (dispatch, getState) => {
  clearAuthToken();
  //dispatch(displayAuthError(messageKey));
  dispatch(clearAuth());
};

/*Bug #612 @Author Aby Joseph @Date 21 Sep 2021 */
export const updateAccount = params => dispatch => {
  dispatch(updateAccountInfo(params));
};
/*End- Bug #612 */

/*Bug #623 @Author Linda Susan Raju @Date 06 Oct 2021 */
export const updateProfileImage = params => dispatch => {
  dispatch(updateUserProfileImage(params));
};
/*End Bug #623 */

/*Bug #664  @author Aby Joseph on 06 Dec 2021 */
export const updateCurrentUser = params => dispatch => {
  dispatch(updateCurrentUserId(params));
};
export const updatefM = params => dispatch => {
  dispatch(updatefMList(params));
};
export const updateBroadcast = params => dispatch => {
  dispatch(updateBroadcastList(params));
};
/*End Bug #664 */
export default authenticationSlice.reducer;